import React from 'react';

import styled from 'styled-components';

import { color } from '../../helpers/style.helpers';

import { Typography } from '@aircall/tractor';

// display table to enable scroll https://stackoverflow.com/questions/23989463/how-to-set-tbody-height-with-overflow-scroll/23989771
export const TableHeader = styled.thead`
  display: table;
  width: 100%;
  border-bottom: 1px solid ${color.grey.light};
  background-color: ${color.grey.lighter};
  table-layout: fixed;
  text-align: left;

  th {
    font-weight: inherit;
  }
`;

const HeaderCellWrapper = styled.th<{ width?: string }>`
  width: ${({ width }) => width};
  padding: 14px 16px;
`;

export interface TableHeaderProps {
  children: React.ReactNode | string;

  /** Width of the column */
  width?: string;
}

export function TableHeaderCell({ children, width }: TableHeaderProps) {
  return (
    <HeaderCellWrapper width={width}>
      <Typography variant='body'>{children}</Typography>
    </HeaderCellWrapper>
  );
}
